import {
    Model
} from '@/lib/BaseModel';
import fieldSpec from '@/models/commonFieldsSchema';

// Message created on Contact Us page
var MessageSchema = {

    uid: {
        label: 'User Id',
        truncate: 30,
        validation: {
            required: 'User Id is required.'
        }
    },

    email: {
        label: fieldSpec.email.label,
        truncate: fieldSpec.email.maxLength,
        validation: {
            email: 'Must be a properly formatted email address.',
            required: 'Email is required.'
        }
    },

    subject: {
        label: 'Subject',
        truncate: 75,
        validation: {
            required: 'Must be filled in.'
        },
    },

    message: {
        label: 'Message',
        truncate: 1000,
        validation: {
            required: 'Must be filled in.'
        },
    }

}

var Message = Model.make('Message', MessageSchema);

export {
    Message
};